// Invite Member
export const INVITE_MEMBER_REQUEST = 'INVITE_MEMBER_REQUEST';
export const INVITE_MEMBER_DONE = 'INVITE_MEMBER_DONE';
export const INVITE_MEMBER_FAILED = 'INVITE_MEMBER_FAILED';